import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loading"
export default class extends Controller {
  static targets = ["text"]

  connect() {
    window.showLoading = this.showLoading.bind(this)
    window.hideLoading = this.hideLoading.bind(this)
  }

  showLoading(text) {
    this.element.hidden = false
    this.textTarget.textContent = `${text}...`;
  }

  hideLoading() {
    this.element.hidden = true
    this.textTarget.textContent = "Loading...";
  }
}
